import React from 'react';
export function HeroSection() {
  return <section id="hero" className="relative pt-20 pb-10 md:pt-24 md:pb-14 px-4 sm:px-6 overflow-hidden" data-id="element-132">
      <div className="max-w-6xl mx-auto flex flex-col items-center text-center" data-id="element-133">
        <div className="inline-block border border-gold/30 bg-gold/10 text-gold text-xs font-bold tracking-widest uppercase px-4 py-1.5 rounded-full mb-8" data-id="element-134">
          FOR MEN 50+
        </div>

        <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold leading-[1.08] mb-5 max-w-4xl text-text-primary" data-id="element-135">
          Stop ED Anxiety In 90 Seconds —<br data-id="element-136" />
          <span className="text-gold" data-id="element-137">Without Pills, Without a Doctor</span>
        </h1>

        <p className="text-lg md:text-xl text-text-secondary max-w-2xl mx-auto mb-8 font-light" data-id="element-138">
          A simple 3-step method for men 50+
          <br data-id="element-139" />
          that works in the exact moment
          <br data-id="element-140" />
          the panic starts. Instant download. $6.39.
        </p>

        <div className="w-full max-w-sm mx-auto mb-12" data-id="element-141">
          <a href="#pricing" className="block w-full bg-gold hover:bg-gold-hover text-dark-bg font-bold text-base py-3.5 px-6 rounded shadow-[0_0_20px_rgba(201,168,76,0.3)] transition-all hover:shadow-[0_0_30px_rgba(201,168,76,0.5)] hover:-translate-y-1" data-id="element-142">
            GET MY COPY — $6.39
          </a>
          <p className="text-text-secondary text-sm mt-4 flex items-center justify-center gap-2" data-id="element-143">
            <span data-id="element-144">Instant download.</span>
            <span className="w-1 h-1 bg-gold rounded-full" data-id="element-145"></span>
            <span data-id="element-146">Private.</span>
            <span className="w-1 h-1 bg-gold rounded-full" data-id="element-147"></span>
            <span data-id="element-148">No subscription.</span>
          </p>
          <p className="text-gold text-sm mt-2 font-medium flex items-center justify-center gap-1" data-id="element-149">
            ✓ 100% Money Back Guarantee — No Questions Asked
          </p>
        </div>

        <div className="w-full max-w-3xl relative" data-id="element-150">
          <div className="absolute inset-0 bg-gradient-to-t from-dark-bg via-transparent to-transparent z-10" data-id="element-151"></div>
          <img src="https://cdn.magicpatterns.com/uploads/9RexrV9B7AUBN21YTtYaTV/private_openrouter-generated-image-1773284425761.png" alt="Erectile Diffusion Guide SR on iPad" className="w-full h-auto rounded-xl shadow-2xl border border-dark-border" data-id="element-152" />
        </div>
      </div>
    </section>;
}